"use client";

import { ActivityDisplayPreview } from "./previews";

type MixedMartialArtsDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function MixedMartialArtsDisplay({
  participants,
}: MixedMartialArtsDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="mixed-martial-arts"
      participants={participants}
    />
  );
}
